import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { PeAuthService } from '../../../../core/services/auth.service';
import { PatientEngagementService } from '../../services/patient-engagement.service';
import { SMSservice } from '../../../../core/services/sms.service';
import { FormGroup } from '@angular/forms';
import { environment } from '../../../../../environments/environment';
import { constant } from '../../../../constants/app.constants';
import { CommmonUtil } from '../utils/common.util';
import { filter, first, firstValueFrom, timeout } from 'rxjs';
import { combineLatest, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class LoginComponent implements OnInit, OnDestroy {
  public logForm!: FormGroup;
  public throwSMS:boolean = false;
  id!: string;
  guid!: string;
  npi!: string;
  token!:string;
  msg_status!:string;
  status!:number;
  image_status!:string;
  elinkData:any;
  isGuestPhoneNumber:any;
  elinkParams:any;
  isGuestUser:boolean= false;
  phInfo:any;
  error_txt:boolean = false;
  loginVisible:boolean = true;
  pharmacyName:string ="Pharmacy Name";
  showErrorPopup: boolean = false;
  currentErrorMessage: string = '';
  isGuestCheck:boolean = false;
  isFrmElink:boolean = false;
  matchPhoneNumber:any;
  isNewUser : boolean =  false;
  currentYear: number;
  pharmacyLogo: any;
  pharmacyInfo: any;
  resp: any;
  isAuthLoading: boolean = true;
  showLoginUI: boolean = false;
  private destroy$ = new Subject<void>();
  private pwaRecoveryCleanup: (() => void) | null = null;

  constructor(
    private _router: Router,
    public auth: AuthService,
    public peAuthService: PeAuthService,
    private _patientEngagementService:PatientEngagementService,
    public _activeRoute: ActivatedRoute,
    public smsService:SMSservice,
    private commonUtil : CommmonUtil) {
      this.currentYear = this.commonUtil.getCurrentYear();
  }

ngOnInit() {
  combineLatest([
    this._activeRoute.params,
    this._activeRoute.queryParams
  ]).pipe(
    takeUntil(this.destroy$)
  ).subscribe(([params, queryParams]) => {
    console.log("1st");

    // ===== CASE 1: eLink params present =====
    if (params && params['id'] && params['guid'] && params['npi']) {
      console.log("2");
      this.loginVisible = false;
      this.isAuthLoading = true;
      localStorage.setItem('paramsData', JSON.stringify(params));
      localStorage.setItem('FromeLink', JSON.stringify(true));
      this.throwSMS = true;
      this.id = params['id'];
      this.guid = params['guid'];
      this.npi = params['npi'];
      this.peAuthService.getElinkData(this.id, this.guid, this.npi).subscribe({
        next: async (response) => {
          if (response) {
              console.log("2.1", response);

              const mobilePaymentSMSPayload = (response as any)?.mobilePaymentSMSPayload;
              const status = (response as any)?.status;

              let mobilePaymentSMS: any = null;


              if (mobilePaymentSMSPayload) {
                try {
                  mobilePaymentSMS = JSON.parse(mobilePaymentSMSPayload);
                } catch (error) {
                  console.error("Error parsing mobilePaymentSMSPayload:", error);
                }
              }

              if (mobilePaymentSMS && mobilePaymentSMS.EntityId !== 0) {
                console.log("2.2", mobilePaymentSMSPayload);
                localStorage.setItem('eLinkData', mobilePaymentSMSPayload);
                this.elinkData = localStorage.getItem("eLinkData") !== 'undefined'
                  ? JSON.parse(localStorage.getItem("eLinkData") || '{}')
                  : {};
                console.log("eLink Data Retrieved:");
                this.handleElinkStatus(response);
              }

              else if (status >= 0) {
                console.log("2.3 (status found, no payload)");
                this.handleElinkStatus(response);
              }

              else {
                console.log("No valid eLink data found");
                this.isAuthLoading = false;
                this.showLoginUI = true;
              }
            }
        },
        error: (error) => {
          console.error('Error occurred:', error);
          this.isAuthLoading = false;
          this.showLoginUI = true;
        }
      });
      return;
    }

    // ===== CASE 2: New user from eLink → auto-redirect to Auth0 signup =====
    if (queryParams && queryParams['isNewUser']) {
      console.log("3");
      this.isAuthLoading = true;
      this.getPharmacyLogo();
      this.isGuestCheck = true;
      this.isFrmElink = true;
      this.isNewUser = true;
      this.signUpWithRedirect();
      this.startPwaRecovery();
      return;
    }

    // ===== CASE 3: Error from Auth0 =====
    if (queryParams && queryParams['error']) {
      console.log("4");
      this.isAuthLoading = false;
      this.showLoginUI = true;
      this.handleError(queryParams['error']);
      return;
    }

    // ===== CASE 4: Normal Auth flow =====
    // Wait until Auth0 finishes loading, then check authentication once
    this.isAuthLoading = true;
    combineLatest([
      this.auth.isLoading$,
      this.auth.isAuthenticated$
    ]).pipe(
      filter(([loading, _]) => !loading),
      first(),
      takeUntil(this.destroy$)
    ).subscribe(async ([_, isAuthenticated]) => {
      if (!isAuthenticated) {
        console.log('[Login] Not authenticated → auto-redirecting to Auth0 login');
        this.loginWithRedirect();
        this.startPwaRecovery();
      } else {
        console.log('[Login] Authenticated → validating token...');
        try {
          const claims = await firstValueFrom(this.auth.idTokenClaims$.pipe(first(), timeout(5000)));
          const token = claims ? claims.__raw : null;
          const exp = claims ? claims.exp : null;

          if (!token) {
            console.warn('[Login] Token missing → forcing logout.');
            await this.peAuthService.logout();
            return;
          }

          const now = Math.floor(Date.now() / 1000);
          console.log('[Login] Token expiry (exp):', exp, 'Current time (now):', now);
          if (!exp || exp < now) {
            console.warn('[Login] Token expired');
            await this.peAuthService.logout();
          } else {
            this.isNewUser = false;
            // Returning user with cached session data → skip callback, go straight to dashboard
            const metaData = localStorage.getItem('MetaData');
            const pharmacyInfo = localStorage.getItem('PharmacyInfo');
            const isValidJson = (val: string | null): boolean => {
              if (!val || val === 'undefined') return false;
              try { JSON.parse(val); return true; } catch { return false; }
            };
            if (isValidJson(metaData) && isValidJson(pharmacyInfo)) {
              console.log('[Login] Token valid + session data cached → going directly to dashboard');
              this._router.navigate(['/PendingPayments']);
            } else {
              console.log('[Login] Token valid but missing session data → going through /callback');
              this._router.navigate(['/callback']);
            }
          }
        } catch (err) {
          console.error('[Login] Error checking token:', err);
          this.isAuthLoading = false;
          this.showLoginUI = true;
        }
      }
    });

    // ===== Load pharmacy name if available =====
    this.elinkData = localStorage.getItem("eLinkData") !== 'undefined'
      ? JSON.parse(localStorage.getItem("eLinkData") || '{}')
      : {};
    this.pharmacyName = this.elinkData?.PharmacyName;
  });
}

ngOnDestroy() {
  this.stopPwaRecovery();
  this.destroy$.next();
  this.destroy$.complete();
}

/**
 * PWA standalone recovery: when Auth0 opens in a Safari sheet / Chrome Custom Tab
 * and the user dismisses it (taps X / Done), the app returns but isAuthLoading is
 * still true → blank screen. We listen to multiple events and use a fallback timer
 * to guarantee recovery.
 */
private startPwaRecovery(): void {
  this.stopPwaRecovery(); // clean up any previous listeners

  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone === true;

  const recover = () => {
    // Only recover if we're still waiting for auth (blank screen state).
    // Show the login UI so the user can tap Login manually instead of
    // reloading (which would auto-redirect to Auth0 again in a loop).
    if (this.isAuthLoading && document.visibilityState === 'visible') {
      console.log('[Login] PWA recovery triggered → showing login UI');
      this.stopPwaRecovery();
      this.isAuthLoading = false;
      this.showLoginUI = true;
    }
  };

  // Use a short delay so the redirect has time to navigate away first.
  // If the redirect succeeds, the page is destroyed and none of this runs.
  const delayedRecover = () => setTimeout(() => recover(), 800);

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      delayedRecover();
    }
  };

  const onFocus = () => delayedRecover();
  const onPageShow = () => delayedRecover();

  document.addEventListener('visibilitychange', onVisibilityChange);
  window.addEventListener('focus', onFocus);
  window.addEventListener('pageshow', onPageShow);

  // Fallback timer: if the page is still here after 4s, the redirect didn't
  // navigate away (e.g. popup was blocked, or user dismissed very quickly).
  // In standalone PWA mode, use a shorter fallback.
  const fallbackMs = isStandalone ? 3000 : 5000;
  const fallbackTimer = setTimeout(() => recover(), fallbackMs);

  this.pwaRecoveryCleanup = () => {
    document.removeEventListener('visibilitychange', onVisibilityChange);
    window.removeEventListener('focus', onFocus);
    window.removeEventListener('pageshow', onPageShow);
    clearTimeout(fallbackTimer);
    this.pwaRecoveryCleanup = null;
  };
}

private stopPwaRecovery(): void {
  if (this.pwaRecoveryCleanup) {
    this.pwaRecoveryCleanup();
  }
}

  async getPharmacyLogo() {
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    this.elinkData = localStorage.getItem("eLinkData")!== 'undefined' ? JSON.parse(localStorage.getItem("eLinkData") || '{}') : {};
    this.phInfo = {
      "isPreLoginFlow": true,
      "pharmacyNpi": this.elinkParams?.npi,
      "patientId": this.elinkData?.EntityId,
      "isPharmacyLogoRequired": true
    };
    try {
      const resp = await this._patientEngagementService.getPharmacyLogo(this.phInfo).toPromise();
      if (resp) {
        try {
          const exists = await this._patientEngagementService.checkImageExists(resp.pharmacyLogo);
          if (exists) {
            this.pharmacyLogo = resp.pharmacyLogo;
          }
          this.pharmacyInfo = resp;
        } catch (error) {
          console.error('Error checking image existence:', error);
        }
      }
    } catch (error) {
      console.error('Error posting pharmacy info:', error);
    }
  }

  //Handling eLink Status Codes
  handleElinkStatus(response: object) {
    const status = (response as any)?.status;
    console.log("eLink Status:", status);
    switch (status) {
      case 0:
        this.handleFailure();
        break;
      case 1:
        this.handleSuccess();
        break;
      case 2:
        this.handleExpiredLink();
        break;
      case 3:
        this.handleFailure();
        break;
      case 4:
        this.handleSubscription();
        break;
    }
  }
  handleSuccess(){
    this.elinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
    if(this.elinkData){
      this.pharmacyName = this.elinkData?.PharmacyName;
        let patientNo = {
          "patientNo": this.elinkData?.EntityId
        }
        this._patientEngagementService.postUserDetails(patientNo).pipe(
          takeUntil(this.destroy$)
        ).subscribe(result =>{
          if(result){
            this.isFrmElink = true;
            this.handleDetailStatus(result);
          }
        });
    }
  }
  handleFailure(){
    this.status = 0;
    this._router.navigate(['/error', this.status]);
  }
  handleExpiredLink(){
    this.status = 2;
    console.log("Navigating to error page with status:", this.status);
    this._router.navigate(['/error', this.status]);
  }
  handleSubscription(){
    this._router.navigate(['/subscribe']);
  }
  //Handling user/Details Status Codes
  handleDetailStatus(response: object){
    let status = (response as any)?.status;
    const identifier = (response as any)?.identifier;
    switch (status) {
      case 0:
        //status 0 user not found then redirect to login screen
        console.log("User not found for signup params");
        this._router.navigate(['/login'], { queryParams: { isGuestCheck: true, isNewUser: true} });
        break;
      case 1:
        //status 1 email user found and email address will be sent in identifier
        this.isNewUser = false;
        const emailUserDetails = {
          npi:this.npi,
          patientID: this.elinkData?.EntityId,
          identifierType: identifier,
          pharmacyLogo : this.pharmacyLogo ? this.pharmacyLogo : null,
          pharmacyInfo : this.pharmacyInfo ? this.pharmacyInfo : null
        };
        this.auth.loginWithRedirect({
          authorizationParams: {
            login_hint: identifier,
            redirect_uri: environment.AUTH0_CALL_BACK,
            emailUserDetails: JSON.stringify(emailUserDetails),
          }
        });
        this.startPwaRecovery();
        break;
      case 2:
        //status 2 guest user found and email address will be sent in identifier phone number, eLink Phone number
        this.isNewUser = false;
        this.continueAsGuestCheck(identifier);
        break;
      default:
        //redirect to login screen
        this.isNewUser = false;
        this._router.navigate(['/login']);
        break;
    }
  }
  showError(message: string) {
    this.currentErrorMessage = message;
    this.showErrorPopup = true;
    this.resetParams();
  }
  handleError(errMsg:any) {
    this.showError(errMsg);
  }
  onCloseErrorPopup() {
    this.showErrorPopup = false;
    this.resetParams();
  }
  resetParams(){
    this._router.navigate([], {
      queryParams: {
        error: null,
        isGuestCheck: null
      },
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }
  loginWithRedirect(): void {
    const pharmacyLogoDetails = {
      pharmacyLogo : this.pharmacyLogo ? this.pharmacyLogo : null,
      pharmacyInfo : this.pharmacyInfo ? this.pharmacyInfo : null
    };
    console.log(environment.AUTH0_CALL_BACK,"CALLBACK");
    console.log(window.location.href,"window.location.href");
    const lastEmail = localStorage.getItem('lastLoginEmail');
    this.auth.loginWithRedirect({
      authorizationParams: {
        redirect_uri: environment.AUTH0_CALL_BACK,
        screen_hint: "login",
        ...(lastEmail ? { login_hint: lastEmail } : {}),
        isFrmElink: this.isFrmElink,
        pharmacyLogoDetails: JSON.stringify(pharmacyLogoDetails)
      }
    });
    this.isFrmElink = false;
  }
  signUpWithRedirect(): void {
    localStorage.setItem('IsGuestUser', JSON.stringify(false));
    this.elinkParams =  JSON.parse(localStorage.getItem('paramsData') as string);
    const pharmacyLogoDetails = {
      pharmacyLogo : this.pharmacyLogo ? this.pharmacyLogo : null,
      pharmacyInfo : this.pharmacyInfo ? this.pharmacyInfo : null
    };
    const pharmacyNpi = this.elinkParams?.npi;
    const patientId = this.elinkData?.EntityId;
    console.log(pharmacyNpi,patientId,String(pharmacyNpi),String(patientId),"SIGNUP CALLBACK");
    this.auth.loginWithRedirect({
      authorizationParams: {
        redirect_uri: environment.AUTH0_CALL_BACK,
        pharmacyNpi: String(pharmacyNpi),
        patientId: String(patientId),
        screen_hint: "signup",
        isFrmElink: this.isFrmElink,
        pharmacyLogoDetails: JSON.stringify(pharmacyLogoDetails)
      }
    });
    this.isFrmElink = false;
  }
  continueAsGuestCheck(identifier:any){
    let withContryPhoneNumber = identifier;
    this.elinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
    this.isGuestPhoneNumber = (this.elinkData as any)?.PatientPhoneNo;
    identifier = (identifier && identifier.length >= 10) ? identifier.slice(-10) : identifier;
    const numReXp = constant.PHONE_NUMBER_TEN_DIGITS_REXP;
      if((identifier && this.isGuestPhoneNumber) && numReXp.test(identifier) && numReXp.test(this.isGuestPhoneNumber)) {
        //identifier phone number, eLink Phone number MATCHING redirecting to continue as guest
        if(identifier === this.isGuestPhoneNumber){
          localStorage.setItem('IsGuestUser', JSON.stringify(true));
          this.matchPhoneNumber = withContryPhoneNumber;
          this._router.navigate(['/login'], { queryParams: { isGuestCheck: true } });
        } else {
          //identifier phone number, eLink Phone number NOT matching redirecting to login screen
          this._router.navigate(['/login'], { queryParams: { isGuestCheck: true } });
        }
      }
  }
  //direct click continue as guest user
  continueAsGuest(){
    const tenantDetails = {
      logo: '',
      tenantName: '',
      fromGuest: 'guestUser'
    };
    localStorage.setItem('IsGuestUser', JSON.stringify(true));
    this.elinkData = JSON.parse(localStorage.getItem('eLinkData') as string);
    this.isGuestPhoneNumber = (this.elinkData as any)?.PatientPhoneNo;
    const pharmacyLogoDetails = {
      pharmacyLogo : this.pharmacyLogo ? this.pharmacyLogo : null,
      pharmacyInfo : this.pharmacyInfo ? this.pharmacyInfo : null
    };
    this.auth.loginWithRedirect({
      authorizationParams: {
        //connection: constant.SMS,
        login_hint: this.isGuestPhoneNumber,
        redirect_uri: environment.AUTH0_CALL_BACK,
        tenantDetails: JSON.stringify(tenantDetails),
        pharmacyLogoDetails: JSON.stringify(pharmacyLogoDetails),
      }
    });
  }
}
